'use client';

import dynamic from 'next/dynamic';

/**
 * `ConcernArticleLinks`, code-split: the catch-all route that renders a
 * Concern page renders every other page too, and only a Concern Article needs
 * it. `ssr: false` because it renders nothing and only acts in the browser.
 */
export const ConcernArticleLinks = dynamic(() => import('./concern-article-links'), { ssr: false });
